module.exports = __webpack_public_path__ + "static/img/venex.fa3bb40e.png";